import React, { useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { classNames } from '../../../../utils';
import CategoryTab from './CategoryTab';
import RemarksTab from './RemarksTab';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '0 0.937rem 0.937rem',
    backgroundColor: '#ffffff',
    padding: '1.875rem 1.875rem ',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tab: {
    height: '2.5rem',
    width: '9.375rem',
    borderRadius: '20px',
    fontSize: '1rem',
  },
  tabSelect: {
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Bold',
    color: '#fff',
  },
  tabUnSelect: {
    backgroundColor: '#f5faff',
    border: 'solid 1px #c0c6cb',
    color: '#c0c6cb',
  },
}));

const EquipmentTab = () => {
  const classes = useStyles();
  const [tabFlag, setTabFlag] = useState(1);
  // 切換 tab
  const tabHandler = (tab) => () => {
    setTabFlag(tab);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.8rem">
        <Box display="flex" alignItems="center">
          <ButtonBase
            className={classNames(classes.tab, tabFlag === 1 ? classes.tabSelect : classes.tabUnSelect)}
            style={{ marginRight: '0.75rem' }}
            onClick={tabHandler(1)}
            id="tab-lend"
          >
            Category
          </ButtonBase>
          <ButtonBase
            className={classNames(classes.tab, tabFlag === 2 ? classes.tabSelect : classes.tabUnSelect)}
            onClick={tabHandler(2)}
            id="tab-borrow"
          >
            Remarks
          </ButtonBase>
        </Box>
      </Box>
      {tabFlag === 1 && <CategoryTab />}
      {tabFlag === 2 && <RemarksTab />}
    </div>
  );
};

export default EquipmentTab;
